import { render, staticRenderFns } from "./i-multi-view.vue?vue&type=template&id=be87fcee&scoped=true&"
import script from "./i-multi-view.vue?vue&type=script&lang=js&"
export * from "./i-multi-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be87fcee",
  null
  
)

export default component.exports